'use client';
import { useCallback, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export interface ReCaptchaParams {
  nonce: number;
  onToken: (token: string | null) => void;
}

export const ReCaptchaComponent = ({ nonce, onToken }: ReCaptchaParams) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (nonce && nonce >= 0) {
      if (!executeRecaptcha) {
        return;
      }

      const token = await executeRecaptcha('onVerify');
      onToken(token);
    }
  }, [executeRecaptcha, onToken, nonce]);

  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return null;
};
